export enum VerifyModalModules {
  RepaymentDetails,
  PaymentDetails,
}
